import React from 'react';
import failImg from '../../../Assets/fail.png';
import successImg from '../../../Assets/success.png';
import runningImg from '../../../Assets/running.png';
import waitingImg from '../../../Assets/waiting.png';
import warningImg from '../../../Assets/warning.png';
import useStyles from '../styles/useStyles';
import { Tooltip } from '@material-ui/core';

export enum ESyncStatus {
    Running = 'Running',
    Success = 'Success',
    Failure = 'Failure',
    Waiting = 'Waiting',
    Warning = 'Warning',
    Error = 'Error',
}

const ImageStatus: React.FC<any> = ({ dataItem, ...props }) => {
    let statusImg;
    switch (dataItem.status) {
        case ESyncStatus.Running:
            statusImg = runningImg;
            break;
        case ESyncStatus.Success:
            statusImg = successImg;
            break;
        case ESyncStatus.Failure:
            statusImg = failImg;
            break;
        case ESyncStatus.Error:
            statusImg = failImg;
            break;
        case ESyncStatus.Waiting:
            statusImg = waitingImg;
            break;
        case ESyncStatus.Warning:
            statusImg = warningImg;
            break;
        default:
            break;
    }

    const classes = useStyles();

    return (
        <td {...props} style={{ textAlignLast: 'center' }}>
            <Tooltip title={dataItem.status}>
                <span>
                    <img className={classes.verticalAlignItem} width={'20px'} src={statusImg} />
                </span>
            </Tooltip>
        </td>
    );
};

export default ImageStatus;
